// extracted by mini-css-extract-plugin
export default {"icon":"timeline-subtitle-item-module__icon--eQ2JG","contentContainer":"timeline-subtitle-item-module__contentContainer--YGMFK","text":"timeline-subtitle-item-module__text--aXz20"};